import {
  GET_DEFAULT_SHARE_PAGE_URL,
  CREATE_SHARE_PAGE_URL
} from 'shared/utils/Constants';

import {
  get,
  post
} from 'shared/services/ApiService';

export const getDefaultSharePage = storyId => {
  return get(GET_DEFAULT_SHARE_PAGE_URL(storyId));
}

export const createSharePage = (story_id, moment_ids) => {
  let params = { story_id, moment_ids };
  return post(CREATE_SHARE_PAGE_URL, params);
}
